import { useParams } from "react-router-dom";

const POLICIES = {
  shipping: {
    title: "Shipping Policy",
    sections: [
      { h: "Delivery times", p: "Orders ship from the United States. Standard nationwide delivery time is 5–7 business days via USPS or UPS. Expedited options may be available on request." },
      { h: "Shipping costs", p: "Free standard shipping on orders over $150 within the continental United States. Below $150, standard shipping is a flat $12." },
      { h: "Tracking", p: "Tracking information is emailed as soon as your package leaves our facility." },
      { h: "Shipping outside the United States", p: "International shipping is available on select items via the eBay marketplace listing. Contact us for a shipping quote before ordering." },
    ],
  },
  returns: {
    title: "Return Policy",
    sections: [
      { h: "Return window", p: "We accept returns within 30 days of delivery. Products must be in original condition, in original packaging." },
      { h: "Return shipping", p: "Buyer is responsible for return shipping unless the item is not as described or arrived defective. In those cases, we provide a prepaid return label." },
      { h: "Refunds", p: "Refunds are issued to the original payment method within 3–5 business days of the returned item's arrival and inspection." },
      { h: "Restocking", p: "A restocking fee may apply to opened items, at our discretion." },
    ],
  },
  warranty: {
    title: "Warranty Policy",
    sections: [
      { h: "Warranty terms", p: "Warranty duration and coverage vary by product and are shown on each product page. Many products carry a lifetime warranty from the manufacturer." },
      { h: "Claim process", p: "Contact support with your order number and a description of the issue. We'll help coordinate the warranty claim with the manufacturer or arrange a replacement." },
      { h: "Limitations", p: "The warranty covers manufacturing defects. It does not cover damage from improper installation, contaminated fuel, or unrelated engine failure." },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    sections: [
      { h: "What we collect", p: "We collect the information you provide when placing an order or submitting an inquiry: name, email, phone, shipping address, and payment information (processed by Stripe — we do not store card data)." },
      { h: "How we use it", p: "To fulfill orders, provide support, and communicate order status. We do not sell personal information." },
      { h: "Cookies", p: "We use cookies to keep you signed in and maintain cart contents." },
      { h: "Your rights", p: "You may request access, correction, or deletion of your personal data by contacting us." },
    ],
  },
  terms: {
    title: "Terms and Conditions",
    sections: [
      { h: "Acceptance", p: "By using this site you agree to these terms. If you don't agree, do not use the site." },
      { h: "Product information", p: "Product data is reproduced from our official eBay listings and updated regularly. Occasional errors may occur; if in doubt, contact us before ordering." },
      { h: "Pricing", p: "Prices are shown in USD and are subject to change. Applicable taxes are calculated at checkout." },
      { h: "Governing law", p: "These terms are governed by the laws of the United States." },
    ],
  },
  accessibility: {
    title: "Accessibility Statement",
    sections: [
      { h: "Commitment", p: "InterCorp Industries is committed to making its website accessible to all users, including those with disabilities. We strive to meet WCAG 2.2 Level AA guidelines." },
      { h: "Features", p: "Keyboard navigation, visible focus states, semantic headings, form labels, image alt text, high-contrast color palette, and reduced-motion support." },
      { h: "Feedback", p: "If you experience an accessibility barrier on this site, please contact us so we can address it." },
    ],
  },
};

export default function Policy() {
  const { slug } = useParams();
  const policy = POLICIES[slug];
  if (!policy) return <div className="max-w-3xl mx-auto p-16 text-center text-slate-500">Policy not found.</div>;
  return (
    <div data-testid={`policy-${slug}`} className="bg-white">
      <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16">
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#0055FF]">Policies</div>
        <h1 className="mt-2 font-display text-3xl lg:text-4xl font-extrabold text-slate-900 tracking-tight">{policy.title}</h1>
        <div className="mt-8 space-y-6">
          {policy.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-heading text-lg font-bold text-slate-900">{s.h}</h2>
              <p className="mt-2 text-slate-600 leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
